import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { mapState, mapActions } from 'vuex';
import D2PageCover from './components/d2-page-cover';
import util from '@/libs/util';
export default {
  components: {
    D2PageCover: D2PageCover,
    labSel: function labSel() {
      return import('../../org/lab_sel.vue');
    }
  },
  computed: _objectSpread({}, mapState('d2admin/user', ['info'])),
  data: function data() {
    return {
      sys_index_logo: '',
      accountCategory: localStorage.getItem('accountCategory'),
      lab_list: [],
      labId: localStorage.getItem('labId') || '',
      lab_show: false,
      labInfo: localStorage.getItem('labInfo') ? JSON.parse(localStorage.getItem('labInfo')) : {}
      //   百度地图
      ,
      markLocation: {},
      mapCenter: {
        lat: 39.908722,
        lng: 116.397499
      },
      inputValue: '',
      searchObj: '',
      showTitle: ''
    };
  },
  mounted: function mounted() {
    console.log('page mounted!!!!!!!');
    this.getLogo();
    if (this.accountCategory !== 'Business') {
      this.getLabs();
    }
    if (this.labId) {
      this.getLabInfo();
    }
  },
  watch: {
    labId: function labId(to) {
      if (to) {
        localStorage.setItem('labId', to);
        this.getLabInfo();
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeAll'])), {}, {
    getLogo: function getLogo() {
      var _this = this;
      this.$api['aboutsCache']('sys_index_logo').then(function (res) {
        if (res.data) {
          _this.sys_index_logo = res.data.sys_index_logo || '';
        }
      });
    },
    sysClick: function sysClick(val) {
      localStorage.setItem('sys', val);
      console.log('sysClick', this.labInfo);
      this.closeAll(true);
      var menuData = localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu')) : [];
      var menu = util.changeMenu(menuData);
      if (val == '数字孪生') {
        if (!this.labInfo.accessDigital) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        if (!this.labInfo.digitalTwinUrl) {
          this.$message.info("\u672A\u914D\u7F6E\u6570\u5B57\u5B6A\u751F\u573A\u666F");
          return;
        }
        // this.$router.push('digitalTwin')
        window.open(this.labInfo.digitalTwinUrl, '_blank');
      } else if (val == '驾驶舱') {
        if (!this.labInfo.accessCockpit) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        if (this.labInfo.cockpitCustom) {
          if (!this.labInfo.cockpitCustomRoute) {
            this.$message.info("\u672A\u586B\u5199\u9A7E\u9A76\u8231\u8DEF\u7531\uFF01");
            return;
          }
          this.$router.push(this.labInfo.cockpitCustomRoute);
          return;
        }
        this.$router.push('largeWater');
      } else if (val == '智慧物联') {
        if (!this.labInfo.accessSmartIot) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        this.$router.push('largeDevice');
      } else if (val == '视频监控') {
        if (!this.labInfo.accessVideo) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        this.$router.push('largeVideo');
      } else if (val == '生产调度') {
        if (!this.labInfo.accessProduction) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        this.$router.push('largeProduct');
      } else if (val == '能耗管控') {
        if (!this.labInfo.accessEnergy) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        this.$router.push('largeEnergy');
      } else if (val == '范蠡大模型') {
        if (!this.labInfo.accessFanli) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        this.$router.push('largeFanli');
      } else if (val == '智能模型') {
        if (!this.labInfo.accessModel) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        window.open(this.labInfo.modelUrl, '_blank');
      } else if (val == '质量溯源') {
        if (!this.labInfo.accessSource) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        this.$router.push('largeSource');
      } else if (val == '精准投喂') {
        if (!this.labInfo.accessFeed) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
      } else if (val == '病害防疫') {
        if (!this.labInfo.accessDisease) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        this.$router.push('largeDisease');
      } else if (val == '自动巡检') {
        if (!this.labInfo.accessPatrol) {
          this.$message.info("\u65E0".concat(val, "\u7CFB\u7EDF\u6743\u9650"));
          return;
        }
        this.$router.push('largeInspection');
      } else if (val == '城市驾驶舱') {
        this.$router.push(this.labInfo.regionCockpitRoute);
      } else {
        this.$store.commit('d2admin/menu/asideSet', menu[0].children);
        this.$router.push(menu[0].href || menu[0].lowerMenus[0].href || menu[0].lowerMenus[0].lowerMenus[0].href);
      }
    },
    getConfig: function getConfig(href) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$api['configsCache']('FanLi_Url');
            case 2:
              res = _context.sent;
              if (!(res.data && res.data.FanLi_Url)) {
                _context.next = 6;
                break;
              }
              _this2.$router.push({
                path: href,
                query: {
                  url: res.data.FanLi_Url
                }
              });
              return _context.abrupt("return");
            case 6:
              _this2.$message.info('管理后台暂未配置路由，请联系管理员处理！');
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getLabs: function getLabs() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.$api['labQuery']({
                page: 1,
                limit: -1
              }).then(function (res) {
                if (res.data) {
                  var _res$data$;
                  _this3.lab_list = res.data || [];
                  _this3.labId = localStorage.getItem('labId') || ((_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.id);
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getLabInfo: function getLabInfo() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.$api['labDetail'](_this4.labId).then(function (res) {
                if (res.data) {
                  localStorage.setItem('labInfo', JSON.stringify(res.data));
                  localStorage.setItem('labId', res.data.id);
                  _this4.labInfo = res.data || {};
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.labId = data.id;
      }
      this.lab_show = false;
    }
  })
};